/* eslint-disable no-shadow */
/* eslint-disable prefer-template */
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Button } from 'reactstrap';
import { useMutation, useQuery } from '@apollo/client';
import {
  ASSIGN_TRADERS_TO_ANOTHER_BDE,
  ASSIGN_TRADERS_TO_ANOTHER_RM,
} from 'pages/Staff/StaffgraphQL';
import { RM_LIST } from 'utils/CommonGraphQL';
import Loader from 'components/common/Loader';
import UserInfo from 'components/UserInfo';
import NoDataFound from 'components/NoDataFound';

const AssignAnotherRMList = ({
  searchString,
  id,
  rowSelection,
  onCloseUpdatePopup,
  drawerToggle,
  roleList = [],
}) => {
  const [selectedItem, setSelectedItem] = useState(null);

  const { data, loading, error } = useQuery(RM_LIST, {
    variables: {
      filter: [
        {
          key: 'firstName',
          value: searchString,
          type: 'STRING',
          op: 'LIKE_OR_NULL',
        },
        {
          key: 'name',
          value: roleList?.length > 0 ? 'BDE' : 'SALES_EXECUTIVE,SALES_HEAD',
          setAttribute: 'roles',
          type: 'STRING',
          op: 'IN',
        },
        {
          key: 'isDeleted',
          value: false,
          type: 'BOOLEAN',
          op: 'EQ',
        },
        {
          key: 'status',
          value: 'ACTIVE',
          type: 'STRING',
          op: 'EQ',
        },
        {
          key: 'id',
          value: id,
          type: 'INT',
          op: 'NEQ',
        },
      ],
      pagination: false,
    },
    fetchPolicy: 'network-only',
  });

  const [assignTradersToAnotherRM] = useMutation(ASSIGN_TRADERS_TO_ANOTHER_RM, {
    onCompleted: ({ assignTradersToAnotherRM }) => {
      if (assignTradersToAnotherRM?.status === 200)
        toast.success(assignTradersToAnotherRM?.message);
      onCloseUpdatePopup();
      drawerToggle();
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
      onCloseUpdatePopup();
      drawerToggle();
    },
  });

  const [assignTradersToAnotherBDE] = useMutation(
    ASSIGN_TRADERS_TO_ANOTHER_BDE,
    {
      onCompleted: ({ assignTradersToAnotherBDE }) => {
        if (assignTradersToAnotherBDE?.status === 200)
          toast.success(assignTradersToAnotherBDE?.message);
        onCloseUpdatePopup();
        drawerToggle();
      },
      onError: ({ graphQLErrors }) => {
        graphQLErrors.map(({ exception }) => {
          toast.error(exception?.message);
          return exception;
        });
        onCloseUpdatePopup();
        drawerToggle();
      },
    },
  );

  const handleRadioChange = (itemId) => {
    setSelectedItem(itemId);
  };

  const handleAddChange = () => {
    if (roleList?.length > 0) {
      try {
        assignTradersToAnotherBDE({
          variables: {
            traders: rowSelection,
            dedicatedBDE: selectedItem,
          },
        });
      } catch (err) {
        console.error(err);
      }
    } else {
      try {
        assignTradersToAnotherRM({
          variables: {
            traders: rowSelection,
            dedicatedRM: selectedItem,
          },
        });
      } catch (err) {
        console.error(err);
      }
    }
  };

  if (loading)
    return (
      <div className="mt-3">
        <Loader />
      </div>
    );
  if (error) return `There is an error on this page : ${error.message} `;

  if (!data?.usersFilter?.users?.length)
    return <NoDataFound message="No data found" />;

  return (
    <div className="vednor-list mt-3">
      <Button
        className="fixed-top-btn small-btn"
        size="sm"
        color="primary"
        onClick={handleAddChange}
        disabled={!selectedItem}
      >
        Assign
      </Button>
      {data?.usersFilter?.users?.map((item) => (
        <div key={item.id} className="d-flex align-items-center user-data">
          <div className="form-check">
            <input
              type="radio"
              id={`radio-${item.id}`}
              className="form-check-input"
              name="selectedItem"
              checked={selectedItem === item.id} // Check if the item is selected
              onChange={() => handleRadioChange(item.id)} // Call handleRadioChange with item ID
            />
          </div>
          <UserInfo
            name={item.firstName + ' ' + item.lastName}
            gstNumber={item?.phone}
          />
        </div>
      ))}
    </div>
  );
};

export default AssignAnotherRMList;
